/** @format */
import {
    Button,
    ButtonVariant,
} from '@mpb-com/feather/components/atoms/button';
import { Heading } from '@mpb-com/feather/components/atoms/heading';
import {
    HeadingColor,
    HeadingSize,
} from '@mpb-com/feather/components/atoms/heading/types';
import React from 'react';

import { WrappedLink } from '@toucan/client/global/nextjs';

import {
    ConstrainedWrapper,
    ConstrainedWrapperGutter,
} from '@toucan/client/shared/components/constrained-wrapper';
import { LinkVariant } from '@toucan/client/shared/components/link';
import { renderMarkdown } from '@toucan/client/shared/helpers/markdown';

import { DEFAULT_TEST_ID } from './constants';
import { StyledSectionPreviewBlock } from './section-preview-block.styles';
import { SectionPreviewBlockProps } from './types';

export {
    SectionPreviewBlockImagePosition,
    SectionPreviewBlockVariant,
} from '@toucan/client/core/contentful';

export * from './types';
export { SectionPreviewBlockSkeleton } from './skeleton';

export const SectionPreviewBlock = ({
    heading,
    description,
    image,
    buttonHref,
    buttonText,
    variant,
    imagePosition,
    'data-testid': dataTestId = DEFAULT_TEST_ID,
    ...otherProps
}: SectionPreviewBlockProps) => {
    return (
        <StyledSectionPreviewBlock
            variant={variant}
            imagePosition={imagePosition}
            data-testid={dataTestId}
            {...otherProps}
        >
            <ConstrainedWrapper gutter={ConstrainedWrapperGutter.SMALL_GUTTER}>
                <div className="content-wrapper">
                    <div className="image">{image}</div>
                    <div className="content">
                        <Heading
                            className="heading"
                            size={HeadingSize.H2}
                            color={HeadingColor.TEXT_INVERSE}
                        >
                            {renderMarkdown(heading)}
                        </Heading>
                        <p className="text">{description}</p>
                        <WrappedLink
                            href={buttonHref}
                            variant={LinkVariant.CUSTOM}
                            passHref={true}
                            className="button"
                        >
                            <Button variant={ButtonVariant.PRIMARY_INVERTED}>
                                {buttonText}
                            </Button>
                        </WrappedLink>
                    </div>
                </div>
            </ConstrainedWrapper>
        </StyledSectionPreviewBlock>
    );
};
